export const theme = {
  colors: {
    black: '#000;',
    yellow: '#D3B908',
    yellowHover: '#FDE025',
    white: '#fff',
    grey: '#c1c1c1',
  },
}
